import { combineReducers } from 'redux'

// import filtroAplicados from "./filtroAplicados"
import detalhesEmpenho from './detalhesEmpenho'
import itensEmpenho from './itensEmpenho'
import credorEmpenho from './credorEmpenho'
import baseLegalEmpenho from './baseLegalEmpenho'
import operacoesEmpenho from './operacoesEmpenho'
import detalhamentoOrcamentario from './detalhamentoOrcamentario'
import valoresEmpenho from './valoresEmpenho'
import liquidacoesComprovantesEmpenho from './liquidacoesComprovantesEmpenho'
import retencoes from './retencoes'
import pagamentos from './pagamentos'

export default combineReducers({
    detalhesEmpenho,
    credorEmpenho,
    baseLegalEmpenho,
    liquidacoesComprovantesEmpenho,
    itensEmpenho,
    operacoesEmpenho,
    detalhamentoOrcamentario,
    valoresEmpenho,
    retencoes,
    pagamentos,
})
